export const useExcelError = {
	nil: '#NULL!',
	div0: '#DIV/0!',
	value: '#VALUE!',
	ref: '#REF!',
	name: '#NAME?',
	num: '#NUM!',
	na: '#N/A',
	error: '#ERROR!',
	data: '#GETTING_DATA',
	calc: '#CALC!',
}

export const useExcelErrorAry = ['#NULL!', '#DIV/0!', '#VALUE!', '#REF!', '#NAME?', '#NUM!', '#N/A', '#ERROR!', '#GETTING_DATA', '#CALC!']
